{
  "alert": "Сигнал",
  "dismiss": "Отхвърляне"
}
